import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { editCategory } from '../../../redux/actions/categoriesActions';
import { snackbarShowMessage } from '../../../redux/actions/snackbarActions';
import { useTranslation } from 'react-i18next';

export default function CategoryEdit({ open, handleClose, categoryToEdit }) {
  const dispatch: any = useDispatch();

  const [statusCategory, setStatusCategory] = useState(
    categoryToEdit.is_active,
  );
  const onClickSaveEquipmentCategory = async () => {
    const response: any = await dispatch(
      editCategory(categoryToEdit.id, {
        is_active: statusCategory,
      }),
    );
    if (response?.status === 200) {
      dispatch(snackbarShowMessage('equipment.category.messages.editSuccess'));
    }
    handleCloseAction();
  };

  const handleCloseAction = () => {
    handleClose();
  };
  const onInputSelectChange = event => {
    setStatusCategory(event.target.value);
  };

  const { t } = useTranslation();

  const createCategoryStrings = {
    create_category: t('createCategories.createCategory'),
    edit_category: t('createCategories.editCategory'),
    new_category: t('createCategories.newCategory'),
    category: t('createCategories.category'),
    add_to_catalog: t('createCategories.addToCatalog'),
    activate: t('createCategories.activate'),
    inactivate: t('createCategories.inactivate'),
  };

  const statusOptions = [
    { name: t('app.common.All'), value: '' },
    { name: t('app.common.active'), value: 1 },
    { name: t('app.common.inactive'), value: 0 },
  ];

  return (
    <Dialog
      open={open}
      onClose={handleCloseAction}
      aria-labelledby="form-dialog-title"
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
    >
      <DialogTitle id="form-dialog-title">
        {createCategoryStrings.edit_category}
      </DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          id="name"
          label={createCategoryStrings.category}
          variant="outlined"
          autoComplete="off"
          size="small"
          value={categoryToEdit.name}
          disabled
        />
        <Select
          label={t('app.common.country')}
          inputProps={{
            name: 'country',
            id: 'search-type',
            size: 'small',
          }}
          value={statusCategory}
          onChange={onInputSelectChange}
        >
          {statusOptions
            .filter(s => s.value !== '')
            .map(status => (
              <MenuItem key="status_true" value={status.value}>
                {status.name}
              </MenuItem>
            ))}
        </Select>
      </DialogContent>
      <DialogActions>
        <Button fullWidth onClick={handleClose} color="primary">
          {t('app.common.cancel')}
        </Button>
        <Button
          onClick={onClickSaveEquipmentCategory}
          fullWidth
          variant="contained"
          color="secondary"
        >
          {t('app.common.save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
